import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  margin-top: ${props => props.theme.whiteLabel.spacing.sp8};
`
